import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="no-iframe"
export default class extends Controller {
  connect() {
    if (window.top.location !== window.location) {
      window.top.location.href = document.location.href;
    }
  }
}
